import _classCallCheck from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ShaderMaterial, UniformsUtils } from 'three';
import { Pass, FullScreenQuad } from '../postprocessing/Pass.js';
import { FilmShader } from '../shaders/FilmShader.js';

var FilmPass = /*#__PURE__*/function (_Pass) {
  _inherits(FilmPass, _Pass);

  var _super = _createSuper(FilmPass);

  function FilmPass(noiseIntensity, scanlinesIntensity, scanlinesCount, grayscale) {
    var _this;

    _classCallCheck(this, FilmPass);

    _this = _super.call(this);
    if (FilmShader === undefined) console.error('THREE.FilmPass relies on FilmShader');
    var shader = FilmShader;
    _this.uniforms = UniformsUtils.clone(shader.uniforms);
    _this.material = new ShaderMaterial({
      uniforms: _this.uniforms,
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader
    });
    if (grayscale !== undefined) _this.uniforms.grayscale.value = grayscale;
    if (noiseIntensity !== undefined) _this.uniforms.nIntensity.value = noiseIntensity;
    if (scanlinesIntensity !== undefined) _this.uniforms.sIntensity.value = scanlinesIntensity;
    if (scanlinesCount !== undefined) _this.uniforms.sCount.value = scanlinesCount;
    _this.fsQuad = new FullScreenQuad(_this.material);
    return _this;
  }

  _createClass(FilmPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer, deltaTime
    /*, maskActive */
    ) {
      this.uniforms['tDiffuse'].value = readBuffer.texture;
      this.uniforms['time'].value += deltaTime;

      if (this.renderToScreen) {
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        this.fsQuad.render(renderer);
      }
    }
  }]);

  return FilmPass;
}(Pass);

export { FilmPass };